import { calcWrapperOffset } from './components/wrapper';

const $doc = $(document);

$doc.on('click', '.js-toggle-opening-hours', function (event) {
  if ($(window).width() < 1025) {
    const $this = $(this);

    $this.toggleClass('is-expanded').next().stop().slideToggle();
  }
});

$doc.on('click', '.js-click', function (event) {
  event.preventDefault();

  const $this = $(this);
  const $element = $($this.attr('href'));

  if (!$element.length) {
    return;
  }

  $this.add($element).toggleClass('is-active');

  if ($this.hasClass('js-anchor')) {
    const scrollOffset = $('.js-header').height();

    $('.js-anchor').not($this).removeClass('is-active');
    $this.addClass('is-active');

    $('html, body').animate({ scrollTop: $element.offset().top - scrollOffset }, 1000);
  }

  if ($this.hasClass('js-toggle-no-scroll')) {
    $('html').toggleClass('no-scroll');
  }

  if ($this.hasClass('js-trigger-search-bar')) {
    $('.js-serach-bar').on('transitionend webkitTransitionEnd oTransitionEnd', function () {
      $(this).find('input').focus();
    });
  }
});

/**
 * [mobileMenuExpand description]
 * @param  {jQuery Selector} $trigger
 * @param  {jQuery Selector} $target
 * @param  {array} dependingElements
 * @param  {string} activeClass
 * @return {void}
 */
export function mobileMenuExpand($trigger, $target, dependingElements, activeClass) {
  $trigger.on('click', function (event) {
    event.preventDefault();

    $target.add(dependingElements).toggleClass(activeClass);

    $('body').toggleClass('locked');

    checkForAnnouncement();
  });
}

export function checkForAnnouncement() {
  setTimeout(function () {
    const additionalSpace = $(window).height() - $('.header').outerHeight();

    $('.header .header__mobile').css({
      'max-height': additionalSpace + 'px',
    });

    calcWrapperOffset();
  }, 300);
}

/**
 * [mobileMenuDropdown description]
 * @param  {jQuery Selector} $trigger
 * @param  {string} parentItemClass
 * @param  {string} activeClass
 * @return {void}
 */
export function mobileMenuDropdown($trigger, parentItemClass, activeClass) {
  $trigger.on('click', function (event) {
    event.preventDefault();

    const $this = $(this);
    const $container = $this.closest(parentItemClass);
    const $dropDown = $container.find('> .menu__dropdown');

    $container.siblings().find('> .menu__dropdown').removeClass(activeClass);

    $dropDown.add($this).toggleClass(activeClass);
  });
}

/**
 * [falseSelect description]
 * @param  {jQuery Selector} $trigger
 * @param  {string} parrentClass
 * @param  {string} activeClass
 * @return {void}
 */
export function falseSelect($trigger, parrentClass, activeClass) {
  $trigger.on('click', function (event) {
    event.preventDefault();

    $(this).closest(parrentClass).toggleClass(activeClass);
  });
}

/**
 * [clickEvent description]
 * @param  {jQuery Selector} $trigger
 * @param  {jQuery Selector} $target
 * @param  {string} activeClass
 * @return {void}
 */
export function clickEvent($trigger, $target, activeClass) {
  $trigger.on('click', function (event) {
    event.preventDefault();

    $target.toggleClass(activeClass);

    checkForAnnouncement();
  });
}
